import { ChartConstants } from "../shared/constants"

export function riesterDefaults() {
	return {
		chart: {
			style: {
				fontFamily: "Open Sans, sans-serif",
				fontSize: ChartConstants.fontSizeKlein,
				fontWeight: 300,
			},
		},

		tooltip: {
			useHTML: true,
			borderRadius: 8,
			split: true,
		},
	}
}
